import { ALL_WAVES } from 'src/types/constants';
import { Continents } from 'src/types/Continents';

type YearLabel = {
  get(key: string | string[]): string;
};
interface Settings {
  highlights: any[];
  language: string;
}
interface Report {
  title: string;
  year: number;
  tag: string;
  color: string;
  baseColor: string;
  disable: boolean;
  type: string;
}
interface UserLogin {
  email: string;
  name: string;
  role: string;
  market?: number[];
}
interface Faq {
  question: string;
  answer: string;
}
interface MainItem {
  title: string;
  icon: string;
  link: string;
}
// const destination_magicnumber_to_add = 356;
const destination_magicnumber_to_add_for_2019 = 356;
const destination_magicnumber_to_add = 0;
export type ITravellyzeState = {
  yearLabel: YearLabel;
  user: User;
  settings: Settings;
  origin_insights: any[];
  archetypes_insights: any[];
  reportList: Report[];
  login: string;
  userLogins: UserLogin[];
  faqs: Faq[];
  marketsOptions2020: Market[];
  marketsOptions2021: Market[];
  marketsOptions2023: Market[];
  marketsSubscriptions: Market[];
  regions: Region[];
  menuSearch;
  menuReportBar: any[];
  menuReportCOP: any[];
  menuReportSUR: any[];
  menuReportCSS: any[];
  menuMain: MainItem[];
  menuMainAdminItem: MainItem;
  WorldCountries: any[];
  fixtures: any[];
  destinationsIDsToRemove2023B: Destination[];
  destinationsIDsToRemove2022B: Destination[];
  destinationsIDsToRemove2024B: Destination[];
  destinationsIDs2025B: Destination[];
  destinationsIDs2025A: Destination[];
  destinationsIDs2024B: Destination[];
  destinationsIDs2024A: Destination[];
  destinationsIDs2023B: Destination[];
  destinationsIDs2023A: Destination[];
  destinationsIDs2022B: Destination[];
  destinationsIDs2022A: Destination[];
  destinationsIDs2021: Destination[];
  destinationsIDs2019: Destination[];
  datasets: Wave2[];
};
export default function (): ITravellyzeState {
  return {
    datasets: ALL_WAVES,
    yearLabel: {
      get(key) {
        const values = {
          202502: '2025 August',
          202501: '2025 January',
          202402: '2024 August',
          202401: '2024 January',
          202302: '2023 August',
          202301: '2023 January',
          202212: '2022',
          202201: '2022 January',
          202202: '2022 August',
          2021: '2021'
        };
        if (Array.isArray(key)) {
          return key.map((year) => values[year]).join(', ');
        } else {
          return values[key] || key;
        }
      }
    },
    user: {} as User,
    settings: {
      highlights: [],
      language: 'en-us'
    },
    origin_insights: [],
    archetypes_insights: [],
    reportList: [
      {
        title: 'Destination Brand Awareness Report',
        year: 202301,
        tag: '',
        color: 'teal-14',
        baseColor: 'teal',
        disable: false,
        type: 'BAR'
      },
      {
        title: 'Competition Brand Awareness Report',
        year: 202301,
        tag: '',
        color: 'orange-14',
        baseColor: 'orange',
        disable: false,
        type: 'BAC'
      },
      {
        title: 'Regional Brand Awareness Report',
        year: 202301,
        tag: '',
        color: 'teal-9',
        baseColor: 'teal',
        disable: false,
        type: 'RAR'
      }
      // {
      //   title: 'Country Snapshot',
      //   year: 202301,
      //   tag: 'New',
      //   color: 'light-blue-7',
      //   baseColor: 'light-blue',
      //   disable: false,
      //   type: 'CSS'
      // },
      // {
      //   title: 'Country OnePager',
      //   year: 202301,
      //   tag: 'New',
      //   color: 'indigo-6',
      //   baseColor: 'indigo',
      //   disable: false,
      //   type: 'COP'
      // },
      // {
      //   title: 'Sustainability Report',
      //   year: 202301,
      //   tag: 'New',
      //   color: 'deep-purple-5',
      //   baseColor: 'deep-purple',
      //   disable: false,
      //   type: 'SUR'
      // }
    ],
    login: 'serena.valle@interfacetourism.com',
    userLogins: [
      { email: 'admin@related.dk', name: 'Admin', role: 'ROLE_ADMIN' },
      {
        email: 'customer@related.dk',
        name: 'Customer',
        role: 'ROLE_MARKET_USER',
        market: [6]
      },
      {
        email: 'chh@related.dk',
        name: 'Chh',
        role: 'ROLE_MARKET_ADMIN',
        market: [1, 2, 3, 4, 5, 9, 10]
      },
      {
        email: 'interface@travellyze.dk',
        name: 'Interface',
        role: 'ROLE_MARKET_ADMIN',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'wearelotus@travellyze.dk',
        name: 'Wearelotus',
        role: 'ROLE_MARKET_ADMIN',
        market: [10, 11, 12, 13, 14]
      },
      {
        email: 'skaddur@andalucia.org',
        name: 'Skaddur',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3, 4, 9]
      },
      {
        email: 'chris.pomeroy@interfacetourism.com',
        name: 'Chris',
        role: 'ROLE_ADMIN'
      },
      {
        email: 'javier.fernandez@interfacetourism.com',
        name: 'Javier',
        role: 'ROLE_ADMIN'
      },
      {
        email: 'nordicuser@related.dk',
        name: 'Nordicuser',
        role: 'ROLE_MARKET_ADMIN',
        market: [1, 2, 3, 4, 5]
      },
      {
        email: 'malgorzata.hudyma@polen.travel',
        name: 'Malgorzata',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3, 4]
      },
      {
        email: 'attilia.bossi@interfacetourism.com',
        name: 'Attilia',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'serena.valle@interfacetourism.com',
        name: 'Serena',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'jeroen.van.wilgen@interfacetourism.com',
        name: 'Jeroen',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'mijke.de.jong@interfacetourism.com',
        name: 'Mijke',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'dorothea.hohn@gce-agency.com',
        name: 'Dorothea',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'monica.fernandez@tourspain.es',
        name: 'Monica',
        role: 'ROLE_MARKET_USER',
        market: [2]
      },
      {
        email: 'Anders.Olesen@austria.info',
        name: 'Anders',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3, 4]
      },
      {
        email: 'psota@promperu.gob.pe',
        name: 'Psota',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3]
      },
      { email: 'cbo@related.dk', name: 'Cbo', role: 'ROLE_MARKET_ADMIN' },
      {
        email: 'salvador.robles@tourspain.es',
        name: 'Salvador',
        role: 'ROLE_MARKET_USER',
        market: [4]
      },
      {
        email: 'ana.marquez@interfacetourism.com',
        name: 'Ana',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'maria.sanchez@interfacetourism.com',
        name: 'Maria',
        role: 'ROLE_MARKET_USER',
        market: [1, 9]
      },
      {
        email: 'laura.chaves@interfacetourism.com',
        name: 'Laura',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'patricia.erustes@interfacetourism.com',
        name: 'Patricia',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'martina.daguanno@interfacetourism.com',
        name: 'Martina',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'claire.pison@interfacetourism.com',
        name: 'Claire',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'alice.kabanoff@interfacetourism.com',
        name: 'Alice',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'sara.cantalapiedra@interfacetourism.com',
        name: 'Sara',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'ast@related.dk',
        name: 'Ast',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3, 4]
      },
      {
        email: 'promotion.act.fr@gencat.cat',
        name: 'Promotion',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3, 4]
      },
      {
        email: 'jon.eshuijs@forwardkeys.com',
        name: 'Jon',
        role: 'ROLE_MARKET_USER'
      },
      {
        email: 'tatiana.freitas@interfacetourism.com',
        name: 'Tatiana',
        role: 'ROLE_MARKET_USER',
        market: [5, 6, 7, 8, 9]
      },
      {
        email: 'Monika.Bosakova@mindop.sk',
        name: 'Monika',
        role: 'ROLE_MARKET_USER',
        market: [1, 2, 3, 4]
      },
      {
        email: 'kali@benns.com',
        name: 'kali',
        role: 'ROLE_MARKET_USER',
        market: [1, 3]
      },
      {
        email: 'jorge.rubio@tourspain.es',
        name: 'Jorge',
        role: 'ROLE_MARKET_USER',
        market: [7]
      },
      {
        email: 'consuelo.lluva@tourspain.es',
        name: 'Consuelo',
        role: 'ROLE_MARKET_USER',
        market: [6]
      },
      {
        email: 'tatiana.martinez@tourspain.es',
        name: 'Tatiana',
        role: 'ROLE_MARKET_USER',
        market: [6]
      },
      {
        email: 'jose.espartero@tourspain.es',
        name: 'Jose',
        role: 'ROLE_MARKET_USER',
        market: [6]
      },
      {
        email: 'jonah@blackdiamond.co.uk',
        name: 'Jonah',
        role: 'ROLE_MARKET_USER',
        market: [10, 11, 12, 13, 14]
      },
      { email: 'coty@madzen.travel', name: 'Coty', role: 'ROLE_ADMIN' },
      {
        email: 'admin@firstcoffee.dk',
        name: 'Admin',
        role: 'ROLE_MARKET_ADMIN'
      },
      { email: 'cpo@travellyze.com', name: 'Cpo', role: 'ROLE_ADMIN' },
      { email: 'jon.roura@gmail.com', name: 'Jon', role: 'ROLE_ADMIN' }
    ],
    faqs: [
      {
        question: 'What is Travellyze?',
        answer:
          'Travellyze is a unique analytics tool designed and built specifically for travel and tourism marketers to help make informed strategic and tactical marketing decisions. At the heart of the platform is an extensive qualitative survey of over 20,000 leisure travellers over 18 years of age. The detailed survey, which takes 30 minutes to complete, provides three distinct blocks of traveller data: demographic, consumer behaviour and destination perception. '
      },
      {
        question: 'Which Markets does Travellyze analyze?',
        answer:
          'Travellyze is increasing its market coverage and currently includes data from the markets of:  United Kingdom, England, Scotland, Northern Ireland, Wales, Germany, France, Netherlands, Spain, Italy , Nordic Countries, Denmark, Sweden, Norway, Finland'
      },
      {
        question: 'How is Travellyze data collected?',
        answer:
          'Twice a year (in January and in August) a comprehensive online consumer intelligence survey is conducted among a fully statistically representative cross section of 1,000-3,500 panelists from each market (depending on the population size of each market). The survey samples are designed to represent the true demographics of each market and cover a fully representative cross section of the adult population of each country. The surveys are carried out by prestigious and fully accredited online panel providers in each the international markets. The panelists demographic information is registered and based on this, a simple and random selection of the market"s inhabitants are drawn. These panelists then receive an online questionnaire.'
      },
      {
        question: 'How can I be sure the data is accurate?',
        answer:
          'The size of the sample is between 3-6 times that required to ensure statistical certainty. We conduct such a large number of surveys to guarantee a high degree of statistical certainty and confidence but also to give ample opportunity for breaking down the background data and applying numerous filters for deep and precise analysis. The extract is simple and random, but stratified so that we get an overall sample that corresponds to the composition of the population in question on criteria such as gender, age and geography. There is deliberately no screening, so everyone can participate regardless of travel habits. The formula used to ensure a 95% confidence interval is the binomial distribution (response rate)'
      },
      {
        question: 'How should I use Travellyze data?',
        answer:
          'The Travellyze database is built on three main blocks of data (Demography, Destination Perception, Traveller Behaviour). Each of these blocks of data includes a variety of different variables. Travellyze’s unique analytics platform allows all data to be combined and crossed between blocks (using “filters”) to offer an almost endless number of possibilities to customize reports and find exactly the insights need. Through cross-referencing options on Travellyze you can identify and segment target audiences and help users understand how these precise traveller segments plan, book and consume travel.'
      },
      {
        question: 'How to create a new profile?',
        answer:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem, eius reprehenderit eos corrupti commodi magni quaerat ex numquam, dolorum officiis modi facere maiores architecto suscipit iste eveniet doloribus ullam aliquid.'
      },
      {
        question: 'How do I edit my profile?',
        answer:
          'On registration you have selected the different levels of information to which you have access. To view and edit your personal profile simply log in to Travellyze and select the profile icon at the top right-hand corner of the screen. Once you are in this page you are free to change your personal information or upgrade your data plan. Be sure to click on “save” before closing the page to ensure that your updated data has been captured. In your profile you will see the markets for which you have access and your data plan. You can purchase additional market data sets by clicking on “upgrade” or by contacting support@travellyze.com . '
      },
      {
        question: 'How do I create a Report?',
        answer:
          'When in your homepage you will see the tab “Reports”, upon entering this page, in the top right-hand corner of the page you will find the option to “create a report”. As you make your way through the creation of the report you will be asked to complete numerous filters, such as indicating the market which you are studying, the destinations which you are interested in as well as the destination factors and the destination’s competitors. After deciding on the filters, you will then be taken to a summary of the report which you are about to compose. Once you have confirmed the filters select, “Create new report”. When the report has been created you will find it listed in your “Report” page. Simply select “Open” to view its results.'
      },
      {
        question: 'How to change date in a research?',
        answer:
          'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem, eius reprehenderit eos corrupti commodi magni quaerat ex numquam, dolorum officiis modi facere maiores architecto suscipit iste eveniet doloribus ullam aliquid.'
      },
      {
        question: 'How can I see historic data?',
        answer:
          'By default, the “research” page, from which you define your search criteria will be set to show the latest survey results. The first Travellyze survey was conducted in the Nordic markets in 2014. The other markets were added in 2020. You can see data from previous surveys and compare these with the current data either by returning to the “Research” page and selecting a year or by changing it while analysing your results by selecting the drop down “Year” menu, found in the top right-hand corner of the page. '
      },
      {
        question: 'What is the Data Confidence indicator?',
        answer:
          'One of the unique features of Travellyze is its ability to apply a variety of filters to precisely define the segment of the population you wish to analyse. To allow users to apply multiple filters we collect data from sample sizes that are at 3-6 times the number required for statistical confidence. Nonetheless as each filter is applied the size of the filter is necessarily reduced. For example, if you start with 3000 responses and apply the filter to analyse female respondents only then the sample size is immediately halved to 1500. Travellyze can guarantee a high degree of statistical certainty and confidence with smaller samples resulting from several filters and sometimes it is interesting to get some insights from even the smallest groups. To allow users to monitor the effect of filters on the segment size and therefore the confidence index Travellyze will rate each filtered search with a simple star system from 3 to 1 stars. 3 stars is the highest degree of statistical certainty (Between 3000 and 500 respondents), 2 stars is smaller (Between 500 and 100 respondents) but still representative sample, 1 star is a small segment (between 100-50 respondents) and can be useful for very specific insights but should be taken as an indication and not a statistical certainty. '
      },
      {
        question:
          'What is the difference between Awareness, Perception, Experience and Image?',
        answer:
          'Awareness = the extent to which a traveller is aware of a country’s tourism offering and the degree of knowledge they think they have about the country as tourism destination. This is also referred to as “front of mind” index. Perception = If a traveller has NOT been to a destination they may still have an organic image of what they expect the destination to be like. This image can be negative, indifferent, or positive (positive enough to want to travel sometime to the destination or so positive that there is a firm desire to travel within the next 3 years).  Experience = If a travel HAS already visited the destination (at any time) they have first-hand experience that can be negative, indifferent or positive (positive enough to want to return to the destination). Image = Image is a combination of a destination’s score in awareness, perception and experience. Our algorithm combines and weights each score to create an overall score for a destination’s image in a given market (or among a given segment of said market). '
      }
    ],

    marketsOptions2020: [
      {
        value: 1,
        label: 'Denmark'
      },
      {
        value: 2,
        label: 'Sweden'
      },
      {
        value: 3,
        label: 'Norway'
      },
      {
        value: 4,
        label: 'Finland'
      },
      {
        value: 44,
        label: 'Nordic Countries'
      },
      {
        value: 5,
        label: 'Germany'
      },
      {
        value: 6,
        label: 'France'
      },
      {
        value: 7,
        label: 'Italy'
      },
      {
        value: 8,
        label: 'Spain'
      },
      {
        value: 9,
        label: 'Netherlands'
      },
      {
        value: 10,
        label: 'United Kingdom'
      }
    ],
    marketsOptions2021: [
      {
        value: 1,
        label: 'Denmark',
        flag: 'fr'
      },
      {
        value: 2,
        label: 'Sweden',
        flag: 'fr'
      },
      {
        value: 3,
        label: 'Norway',
        flag: 'fr'
      },
      {
        value: 4,
        label: 'Finland',
        flag: 'fr'
      },
      {
        value: 44,
        label: 'Nordic Countries',
        flag: 'fr'
      },
      {
        value: 5,
        label: 'Germany',
        flag: 'fr'
      },
      {
        value: 6,
        label: 'France',
        flag: 'fr'
      },
      {
        value: 7,
        label: 'Italy',
        flag: 'fr'
      },
      {
        value: 8,
        label: 'Spain',
        flag: 'fr'
      },
      {
        value: 9,
        label: 'Netherlands',
        flag: 'fr'
      },
      {
        value: 10,
        label: 'United Kingdom',
        flag: 'fr'
      }
    ],
    marketsOptions2023: [
      {
        value: 0,
        label: 'All markets',
        flag: 'fr'
      },
      {
        value: 1,
        label: 'Denmark',
        flag: 'fr'
      },
      {
        value: 2,
        label: 'Sweden',
        flag: 'fr'
      },
      {
        value: 3,
        label: 'Norway',
        flag: 'fr'
      },
      {
        value: 4,
        label: 'Finland',
        flag: 'fr'
      },
      {
        value: 44,
        label: 'Nordic Countries',
        flag: 'fr'
      },
      {
        value: 5,
        label: 'Germany',
        flag: 'fr'
      },
      {
        value: 6,
        label: 'France',
        flag: 'fr'
      },
      {
        value: 7,
        label: 'Italy',
        flag: 'fr'
      },
      {
        value: 8,
        label: 'Spain',
        flag: 'fr'
      },
      {
        value: 9,
        label: 'Netherlands',
        flag: 'fr'
      },
      {
        value: 10,
        label: 'United Kingdom',
        flag: 'fr'
      }
    ],
    marketsSubscriptions: [
      {
        value: 1,
        label: 'Denmark',
        flag: 'fr'
      },
      {
        value: 2,
        label: 'Sweden',
        flag: 'fr'
      },
      {
        value: 3,
        label: 'Norway',
        flag: 'fr'
      },
      {
        value: 4,
        label: 'Finland',
        flag: 'fr'
      },
      {
        value: 5,
        label: 'Germany',
        flag: 'fr'
      },
      {
        value: 6,
        label: 'France',
        flag: 'fr'
      },
      {
        value: 7,
        label: 'Italy',
        flag: 'fr'
      },
      {
        value: 8,
        label: 'Spain',
        flag: 'fr'
      },
      {
        value: 9,
        label: 'Netherlands',
        flag: 'fr'
      },
      {
        value: 10,
        label: 'United Kingdom',
        flag: 'fr'
      }
    ],
    regions: [
      {
        value: 1,
        label: 'Hovedstaden',
        country: 'Denmark'
      },
      {
        value: 2,
        label: 'Sjælland',
        country: 'Denmark'
      },
      {
        value: 3,
        label: 'Syddanmark',
        country: 'Denmark'
      },
      {
        value: 4,
        label: 'Midtjylland',
        country: 'Denmark'
      },
      {
        value: 5,
        label: 'Nordjylland',
        country: 'Denmark'
      },
      {
        value: 6,
        label: 'Götaland',
        country: 'Sweden'
      },
      {
        value: 7,
        label: 'Västra Götaland',
        country: 'Sweden'
      },
      {
        value: 8,
        label: 'Svealand',
        country: 'Sweden'
      },
      {
        value: 9,
        label: 'Södra Norrland',
        country: 'Sweden'
      },
      {
        value: 10,
        label: 'Mellersta Norrland',
        country: 'Sweden'
      },
      {
        value: 11,
        label: 'Norra Norrland',
        country: 'Sweden'
      },
      {
        value: 12,
        label: 'Sørlandet',
        country: 'Norway'
      },
      {
        value: 13,
        label: 'Østlandet',
        country: 'Norway'
      },
      {
        value: 14,
        label: 'Vestlandet',
        country: 'Norway'
      },
      {
        value: 15,
        label: 'Nord Norge',
        country: 'Norway'
      },
      {
        value: 16,
        label: 'Trøndelag',
        country: 'Norway'
      },
      {
        value: 17,
        label: 'Etelä-Suomen lääni',
        country: 'Finland'
      },
      {
        value: 18,
        label: 'Länsi-Suomen lääni',
        country: 'Finland'
      },
      {
        value: 19,
        label: 'Itä-Suomen lääni',
        country: 'Finland'
      },
      {
        value: 20,
        label: 'Oulun lääni',
        country: 'Finland'
      },
      {
        value: 21,
        label: 'Läpin lääni',
        country: 'Finland'
      },
      {
        value: 110,
        label: 'Keski-Suomi',
        country: 'Finland'
      },
      {
        value: 22,
        label: 'Baden-Württemberg',
        country: 'Germany'
      },
      {
        value: 23,
        label: 'Bayern',
        country: 'Germany'
      },
      {
        value: 24,
        label: 'Berlin',
        country: 'Germany'
      },
      {
        value: 25,
        label: 'Brandenburg',
        country: 'Germany'
      },
      {
        value: 26,
        label: 'Bremen',
        country: 'Germany'
      },
      {
        value: 27,
        label: 'Hamburg',
        country: 'Germany'
      },
      {
        value: 28,
        label: 'Hessen',
        country: 'Germany'
      },
      {
        value: 29,
        label: 'Mecklenburg-Vorpommern',
        country: 'Germany'
      },
      {
        value: 30,
        label: 'Niedersachsen',
        country: 'Germany'
      },
      {
        value: 31,
        label: 'Nordrhein-Westfalen',
        country: 'Germany'
      },
      {
        value: 32,
        label: 'Rheinland-Pfalz',
        country: 'Germany'
      },
      {
        value: 33,
        label: 'Saarland',
        country: 'Germany'
      },
      {
        value: 34,
        label: 'Sachsen',
        country: 'Germany'
      },
      {
        value: 35,
        label: 'Sachsen-Anhalt',
        country: 'Germany'
      },
      {
        value: 36,
        label: 'Schleswig Holstein',
        country: 'Germany'
      },
      {
        value: 37,
        label: 'Thüringen',
        country: 'Germany'
      },

      {
        value: 38,
        label: 'Auvergne-Rhône-Alpes',
        country: 'France'
      },
      {
        value: 39,
        label: 'Bourgogne-Franche-Comté',
        country: 'France'
      },
      {
        value: 40,
        label: 'Bretagne',
        country: 'France'
      },
      {
        value: 41,
        label: 'Centre-Val de Loire',
        country: 'France'
      },
      {
        value: 42,
        label: 'Corse',
        country: 'France'
      },
      {
        value: 43,
        label: 'Grand Est',
        country: 'France'
      },
      {
        value: 44,
        label: 'Hauts-de-France',
        country: 'France'
      },
      {
        value: 45,
        label: 'Ile-de-France',
        country: 'France'
      },
      {
        value: 46,
        label: 'Normandie',
        country: 'France'
      },
      {
        value: 47,
        label: 'Nouvelle-Aquitaine',
        country: 'France'
      },
      {
        value: 48,
        label: 'Occitanie',
        country: 'France'
      },
      {
        value: 49,
        label: 'Pays de la Loire',
        country: 'France'
      },
      {
        value: 50,
        label: 'Provence-Alpes',
        country: 'France'
      },
      {
        value: 51,
        label: 'Côte d’Azur',
        country: 'France'
      },
      {
        value: 52,
        label: "Valle d'Aosta",
        country: 'Italy'
      },
      {
        value: 53,
        label: 'Piemonte',
        country: 'Italy'
      },
      {
        value: 54,
        label: 'Lombardia',
        country: 'Italy'
      },
      {
        value: 55,
        label: 'Trentino Alto Adige',
        country: 'Italy'
      },
      {
        value: 56,
        label: 'Veneto',
        country: 'Italy'
      },
      {
        value: 57,
        label: 'Friuli Venezia Giulia',
        country: 'Italy'
      },
      {
        value: 58,
        label: 'Emilia Romagna',
        country: 'Italy'
      },
      {
        value: 59,
        label: 'Liguria',
        country: 'Italy'
      },
      {
        value: 60,
        label: 'Toscana',
        country: 'Italy'
      },
      {
        value: 61,
        label: 'Umbria',
        country: 'Italy'
      },
      {
        value: 62,
        label: 'Marche',
        country: 'Italy'
      },
      {
        value: 63,
        label: 'Abruzzo',
        country: 'Italy'
      },
      {
        value: 64,
        label: 'Lazio',
        country: 'Italy'
      },
      {
        value: 65,
        label: 'Campania',
        country: 'Italy'
      },
      {
        value: 66,
        label: 'Calabria',
        country: 'Italy'
      },
      {
        value: 67,
        label: 'Basilicata',
        country: 'Italy'
      },
      {
        value: 68,
        label: 'Molise',
        country: 'Italy'
      },
      {
        value: 69,
        label: 'Puglia',
        country: 'Italy'
      },
      {
        value: 70,
        label: 'Sicilia',
        country: 'Italy'
      },
      {
        value: 71,
        label: 'Sardegna',
        country: 'Italy'
      },
      {
        value: 72,
        label: 'País Vasco',
        country: 'Spain'
      },
      {
        value: 73,
        label: 'Cataluña',
        country: 'Spain'
      },
      {
        value: 74,
        label: 'Galicia',
        country: 'Spain'
      },
      {
        value: 75,
        label: 'Andalusia',
        country: 'Spain'
      },
      {
        value: 76,
        label: 'Asturias',
        country: 'Spain'
      },
      {
        value: 77,
        label: 'Cantabria',
        country: 'Spain'
      },
      {
        value: 78,
        label: 'La Rioja',
        country: 'Spain'
      },
      {
        value: 79,
        label: 'Región de Murcia',
        country: 'Spain'
      },
      {
        value: 80,
        label: 'Comunidad Valenciana',
        country: 'Spain'
      },
      {
        value: 81,
        label: 'Aragón',
        country: 'Spain'
      },
      {
        value: 82,
        label: 'Castilla-La Mancha',
        country: 'Spain'
      },
      {
        value: 83,
        label: 'Canarias',
        country: 'Spain'
      },
      {
        value: 84,
        label: 'Navarra',
        country: 'Spain'
      },
      {
        value: 85,
        label: 'Extremadura',
        country: 'Spain'
      },
      {
        value: 86,
        label: 'Baleares',
        country: 'Spain'
      },
      {
        value: 87,
        label: 'Comunidad de Madrid',
        country: 'Spain'
      },
      {
        value: 88,
        label: 'Castilla y León',
        country: 'Spain'
      },
      {
        value: 111,
        label: 'Ceuta',
        country: 'Spain'
      },
      {
        value: 112,
        label: 'Melilla',
        country: 'Spain'
      },
      {
        value: 89,
        label: 'Noord-Holland',
        country: 'Netherlands'
      },
      {
        value: 90,
        label: 'Zuid-Holland',
        country: 'Netherlands'
      },
      {
        value: 91,
        label: 'Utrecht',
        country: 'Netherlands'
      },
      {
        value: 92,
        label: 'Flevoland',
        country: 'Netherlands'
      },
      {
        value: 93,
        label: 'Zeeland',
        country: 'Netherlands'
      },
      {
        value: 94,
        label: 'Noord-Brabant',
        country: 'Netherlands'
      },
      {
        value: 95,
        label: 'Limburg',
        country: 'Netherlands'
      },
      {
        value: 96,
        label: 'Gelderland',
        country: 'Netherlands'
      },
      {
        value: 97,
        label: 'Overijssel',
        country: 'Netherlands'
      },
      {
        value: 98,
        label: 'Drenthe',
        country: 'Netherlands'
      },
      {
        value: 99,
        label: 'Groningen',
        country: 'Netherlands'
      },
      {
        value: 100,
        label: 'Friesland',
        country: 'Netherlands'
      },

      //UK
      {
        value: [101, 102],
        label: 'North of England',
        country: 'United Kingdom'
      },
      {
        value: [115, 116, 117, 118],
        label: 'Midlands',
        country: 'United Kingdom'
        // England - Midlands - East   115
        // England - Midlands - West   116
        // Yorkshire and The Humber    117
        // East of England             118
      },
      {
        value: [104, 106],
        label: 'London & South East',
        country: 'United Kingdom'
      },
      {
        value: 105,
        label: 'England - South West',
        country: 'United Kingdom'
      },
      {
        value: 108,
        label: 'Scotland',
        country: 'United Kingdom'
      },
      {
        value: 109,
        label: 'Wales',
        country: 'United Kingdom'
      },
      {
        value: 107,
        label: 'Northern Ireland',
        country: 'United Kingdom'
      }
    ],
    menuSearch: [
      {
        group: 'Market Research',
        items: [
          {
            // id: 1,
            title: 'Demographics',
            icon: 'las la-user',
            link: 'demographics'
          },
          {
            // id: 2,
            title: 'Budget Planning',
            icon: 'las la-wallet',
            link: 'budget'
          },
          {
            // id: 3,
            title: 'Travel Inspirations',
            icon: 'las la-lightbulb',
            link: 'inspirations'
          },
          {
            // id: 4,
            title: 'Destination Factors',
            icon: 'las la-route',
            link: 'factors',
            ignore: {
              year: [
                202502, 202501, 202402, 202402, 202401, 202301, 202302, 2022,
                202202, 202201, 2021, 2017, 2016
              ],
              jmw: true
            }
          },
          {
            // id: 60,
            title: 'Travel Drivers',
            icon: 'las la-search-location',
            link: 'catalysts',
            ignore: {
              year: [2020, 2019, 2018, 2017, 2016, 2015, 2014]
            }
          },
          {
            // id: 61,
            title: 'Travel Essentials',
            icon: 'las la-route',
            link: 'enablers',
            ignore: {
              year: [2020, 2019, 2018, 2017, 2016, 2015, 2014]
            }
          },
          {
            // id: 57,
            title: 'Travel Barriers',
            icon: 'las la-search-minus',
            link: 'barriers',
            ignore: {
              year: [202201, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014]
            }
          },
          {
            // id: 5,
            title: 'Behaviour Analysis',
            icon: 'las la-heartbeat',
            link: 'behaviours',
            items: [
              {
                // id: 51,
                title: 'Travel Booking',
                link: 'booking'
              },
              {
                // id: 52,
                title: 'Travel Times',
                link: 'times',
                ignore: {
                  year: [2019, 2018, 2017, 2016, 2015, 2014]
                }
              },
              {
                // id: 58,
                title: 'Travel Quantities',
                link: 'quantities',
                ignore: {
                  year: [202201, 2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014]
                }
              },
              {
                // id: 53,
                title: 'Travel Accommodation',
                link: 'accommodation'
              },
              {
                // id: 56,
                title: 'Holiday Type',
                link: 'holiday',
                ignore: {
                  year: [2019, 2018, 2017, 2016, 2015, 2014]
                }
              },
              {
                // id: 59,
                title: 'Travel Transport',
                link: 'transport',
                ignore: {
                  year: [2019, 2018, 2017, 2016, 2015, 2014]
                }
                // ignore: {
                //   year: [
                //     202301, 202212, 202202, 202201, 2021, 2020, 2019, 2018,
                //     2017, 2016, 2015, 2014
                //   ]
                // }
              },
              {
                // id: 54,
                title: 'Travel Behaviours',
                link: 'behaviours',
                ignore: {
                  year: [2021, 2020, 2019, 2018, 2017, 2016, 2015, 2014]
                }
              }
              //   {
              //     title: 'Duty Free',
              //     link: 'duty',
              //     ignore: {
              //       year: [
              //         202501, 202402, 202401, 202302, 202301, 202202, 2021, 2020,
              //         2019, 2018, 2017, 2016, 2015, 2014
              //       ]
              //     }
              //   }
            ]
          }
        ]
      },
      {
        group: 'Destination Research',
        items: [
          {
            id: 6,
            title: 'Image Rank',
            icon: 'insights',
            link: 'image'
          },
          {
            id: 7,
            title: 'Awareness',
            icon: 'las la-crosshairs',
            link: 'awareness'
          },
          {
            id: 8,
            title: 'Perception Analysis',
            icon: 'las la-check-circle',
            link: 'perception',
            items: [
              {
                id: 81,
                title: 'Destination Perception',
                link: 'perception'
              },
              {
                id: 82,
                title: 'Destination Appeal',
                link: 'appeal'
              },
              {
                id: 83,
                title: 'Destination Short Term Demand',
                link: 'demand'
              }
            ]
          },
          {
            id: 9,
            title: 'Experience Analysis',
            icon: 'las la-plane-arrival',
            link: 'experience',
            items: [
              {
                id: 91,
                title: 'Destination Experience',
                link: 'experience'
              },
              {
                id: 92,
                title: 'Visitation Analysis',
                link: 'visitation'
              },
              {
                id: 93,
                title: 'Revisitors Analysis',
                link: 'revisitors'
              }
            ]
          }
        ]
      }
    ],
    menuReportBar: [
      {
        group: 'Report Content',
        items: [
          {
            title: 'Introduction',
            icon: 'layers',
            link: 'intro'
          },
          {
            title: 'Demographics',
            icon: 'las la-users',
            link: 'demo'
          },
          {
            title: 'Brand Position',
            icon: 'insights',
            link: 'position'
          },
          {
            title: 'Perception Audit',
            icon: 'las la-check-circle',
            link: 'perception'
          },
          {
            title: 'Experience Audit',
            icon: 'las la-plane-arrival',
            link: 'experience'
          },
          {
            title: 'The Ultimate Traveller',
            icon: 'las la-user',
            link: 'ultimate'
          }
        ]
      }
    ],
    menuReportCOP: [
      {
        group: 'Report Content',
        items: [
          {
            title: 'One Pager',
            icon: 'description',
            link: 'introduction'
          }
        ]
      }
    ],
    menuReportSUR: [
      {
        group: 'Report Content',
        items: [
          {
            title: '1. Sustainable Travellers',
            icon: 'layers',
            link: 'overview1'
          },
          {
            title: '2. Environmental Concerns',
            icon: 'las la-leaf',
            link: 'overview2',
            items: [
              {
                title: 'Overview',
                link: 'overview2'
              },
              {
                title: 'Destinations',
                link: 'destinations2'
              },
              {
                title: 'Ultimate Traveller',
                link: 'ultimate2'
              }
            ]
          },
          {
            title: '3. Carbon Footprint',
            icon: 'las la-smog',
            link: 'overview3',
            items: [
              {
                title: 'Overview',
                link: 'overview3'
              },
              {
                title: 'Destinations',
                link: 'destinations3'
              },
              {
                title: 'Ultimate Traveller',
                link: 'ultimate3'
              }
            ]
          }
        ]
      }
    ],
    menuReportCSS: [
      {
        group: 'Report Content',
        items: [
          {
            title: 'Demographics',
            icon: 'las la-user',
            link: 'demographics'
          },
          {
            title: 'Budget Planning',
            icon: 'las la-wallet',
            link: 'budget'
          },
          {
            title: 'Inspirations',
            icon: 'las la-lightbulb',
            link: 'inspirations'
          },
          {
            title: 'Factors',
            icon: 'las la-route',
            link: 'factors'
          },
          {
            title: 'Holiday Type',
            icon: 'las la-suitcase-rolling',
            link: 'holiday'
          },
          {
            title: 'Accomodation',
            icon: 'las la-bed',
            link: 'accomodation'
          },
          {
            title: 'Travel Times',
            icon: 'las la-calendar-alt',
            link: 'times'
          },
          {
            title: 'Booking',
            icon: 'las la-check-circle',
            link: 'booking'
          },
          {
            title: 'Transportation',
            icon: 'las la-car',
            link: 'transportation'
          },
          {
            title: 'Apprehension',
            icon: 'las la-exclamation-triangle',
            link: 'apprehension'
          },
          {
            title: 'Destination Image',
            icon: 'insights',
            link: 'image'
          },
          {
            title: 'Destination Awareness',
            icon: 'las la-crosshairs',
            link: 'awareness'
          },
          {
            title: 'Destination Perception',
            icon: 'las la-check-circle',
            link: 'perception'
          },
          {
            title: 'Destination Experience',
            icon: 'las la-plane-arrival',
            link: 'experience'
          },
          {
            title: 'The Ultimate Traveller',
            icon: 'las la-user',
            link: 'ultimate'
          }
        ]
      }
    ],
    menuMain: [
      {
        title: 'Research',
        icon: 'las la-users',
        link: 'research'
      },
      {
        title: 'Favorites',
        icon: 'favorite_border',
        link: 'favorites'
      },
      {
        title: 'Buyer Personas',
        icon: 'person',
        link: 'buyer-personas'
      },
      {
        title: 'Back to Destination',
        icon: 'undo',
        link: 'https://app.travellyze.com/'
      }
    ],
    menuMainAdminItem: {
      title: 'Admin Panel',
      icon: 'web',
      link: 'admin'
    },
    WorldCountries: [
      'Afghanistan',
      'Albania',
      'Algeria',
      'American Samoa',
      'Andorra',
      'Angola',
      'Anguilla',
      'Antarctica',
      'Antigua and/or Barbuda',
      'Argentina',
      'Armenia',
      'Aruba',
      'Australia',
      'Austria',
      'Azerbaijan',
      'Bahamas',
      'Bahrain',
      'Bangladesh',
      'Barbados',
      'Belarus',
      'Belgium',
      'Belize',
      'Benin',
      'Bermuda',
      'Bhutan',
      'Bolivia',
      'Bosnia and Herzegovina',
      'Botswana',
      'Bouvet Island',
      'Brazil',
      'British Indian Ocean Territory',
      'Brunei Darussalam',
      'Bulgaria',
      'Burkina Faso',
      'Burundi',
      'Cambodia',
      'Cameroon',
      'Canada',
      'Cape Verde',
      'Cayman Islands',
      'Central African Republic',
      'Chad',
      'Chile',
      'China',
      'Christmas Island',
      'Cocos (Keeling) Islands',
      'Colombia',
      'Comoros',
      'Congo',
      'Cook Islands',
      'Costa Rica',
      'Croatia (Hrvatska)',
      'Cuba',
      'Cyprus',
      'Czech Republic',
      'Denmark',
      'Djibouti',
      'Dominica',
      'Dominican Republic',
      'East Timor',
      'Ecudaor',
      'Egypt',
      'El Salvador',
      'Equatorial Guinea',
      'Eritrea',
      'Estonia',
      'Ethiopia',
      'Falkland Islands (Malvinas)',
      'Faroe Islands',
      'Fiji',
      'Finland',
      'France',
      'France, Metropolitan',
      'French Guiana',
      'French Polynesia',
      'French Southern Territories',
      'Gabon',
      'Gambia',
      'Georgia',
      'Germany',
      'Ghana',
      'Gibraltar',
      'Greece',
      'Greenland',
      'Grenada',
      'Guadeloupe',
      'Guam',
      'Guatemala',
      'Guinea',
      'Guinea-Bissau',
      'Guyana',
      'Haiti',
      'Heard and Mc Donald Islands',
      'Honduras',
      'Hong Kong',
      'Hungary',
      'Iceland',
      'India',
      'Indonesia',
      'Iran (Islamic Republic of)',
      'Iraq',
      'Ireland',
      'Israel',
      'Italy',
      'Ivory Coast',
      'Jamaica',
      'Japan',
      'Jordan',
      'Kazakhstan',
      'Kenya',
      'Kiribati',
      "Korea, Democratic People's Republic of",
      'Korea, Republic of',
      'Kosovo',
      'Kuwait',
      'Kyrgyzstan',
      "Lao People's Democratic Republic",
      'Latvia',
      'Lebanon',
      'Lesotho',
      'Liberia',
      'Libyan Arab Jamahiriya',
      'Liechtenstein',
      'Lithuania',
      'Luxembourg',
      'Macau',
      'Macedonia',
      'Madagascar',
      'Malawi',
      'Malaysia',
      'Maldives',
      'Mali',
      'Malta',
      'Marshall Islands',
      'Martinique',
      'Mauritania',
      'Mauritius',
      'Mayotte',
      'Mexico',
      'Micronesia, Federated States of',
      'Moldova, Republic of',
      'Monaco',
      'Mongolia',
      'Montserrat',
      'Morocco',
      'Mozambique',
      'Myanmar',
      'Namibia',
      'Nauru',
      'Nepal',
      'Netherlands',
      'Netherlands Antilles',
      'New Caledonia',
      'New Zealand',
      'Nicaragua',
      'Niger',
      'Nigeria',
      'Niue',
      'Norfork Island',
      'Northern Mariana Islands',
      'Norway',
      'Oman',
      'Pakistan',
      'Palau',
      'Panama',
      'Papua New Guinea',
      'Paraguay',
      'Peru',
      'Philippines',
      'Pitcairn',
      'Poland',
      'Portugal',
      'Puerto Rico',
      'Qatar',
      'Reunion',
      'Romania',
      'Russian Federation',
      'Rwanda',
      'Saint Kitts and Nevis',
      'Saint Lucia',
      'Saint Vincent and the Grenadines',
      'Samoa',
      'San Marino',
      'Sao Tome and Principe',
      'Saudi Arabia',
      'Senegal',
      'Seychelles',
      'Sierra Leone',
      'Singapore',
      'Slovakia',
      'Slovenia',
      'Solomon Islands',
      'Somalia',
      'South Africa',
      'South Georgia South Sandwich Islands',
      'South Sudan',
      'Spain',
      'Sri Lanka',
      'St. Helena',
      'St. Pierre and Miquelon',
      'Sudan',
      'Suriname',
      'Svalbarn and Jan Mayen Islands',
      'Swaziland',
      'Sweden',
      'Switzerland',
      'Syrian Arab Republic',
      'Taiwan',
      'Tajikistan',
      'Tanzania, United Republic of',
      'Thailand',
      'Togo',
      'Tokelau',
      'Tonga',
      'Trinidad and Tobago',
      'Tunisia',
      'Turkey',
      'Turkmenistan',
      'Turks and Caicos Islands',
      'Tuvalu',
      'Uganda',
      'Ukraine',
      'United Arab Emirates',
      'United Kingdom',
      'United States',
      'United States minor outlying islands',
      'Uruguay',
      'Uzbekistan',
      'Vanuatu',
      'Vatican City State',
      'Venezuela',
      'Vietnam',
      'Virigan Islands (British)',
      'Virgin Islands (U.S.)',
      'Wallis and Futuna Islands',
      'Western Sahara',
      'Yemen',
      'Yugoslavia',
      'Zaire',
      'Zambia',
      'Zimbabwe'
    ],
    fixtures: [
      {
        old: 'Ras Al Khaimah',
        new: 'Ras al Khaimah'
      },
      {
        old: 'Phillipines',
        new: 'Philippines'
      },
      {
        old: 'Burma',
        new: 'Myanmar (Burma)'
      },
      {
        old: 'Tansania',
        new: 'Tanzania'
      },
      {
        old: 'The Dominican Rep.',
        new: 'The Dominican Republic'
      },
      {
        old: 'USA',
        new: 'United States of America'
      },
      {
        old: 'Azerbaijan',
        new: 'Azerbaijan'
      },
      {
        old: 'Bosnia-Herzegovina',
        new: 'Bosnia y Herzegovina'
      },
      {
        old: 'Croatia',
        new: 'Croacia'
      },
      {
        old: 'Czech republic',
        new: 'Czech Republic'
      },
      {
        old: 'UK',
        new: 'United Kingdom'
      },
      {
        old: 'Balearics',
        new: 'Balearic Islands'
      },
      {
        old: 'Trinidad',
        new: 'Trinidad and Tobago'
      }
    ],

    destinationsIDsToRemove2023B: [
      {
        value: 125,
        label: 'Trinidad & Tobago',
        continent: Continents.America
      },
      {
        value: 270,
        label: 'Curacao',
        continent: Continents.America
      },
      {
        value: 213,
        label: 'Antigua and Barbuda',
        continent: Continents.America
      },
      {
        value: 281,
        label: 'Trentino',
        continent: Continents['Other destinations']
      }
    ],
    destinationsIDsToRemove2022B: [
      {
        value: 226,
        label: 'Jersey',
        continent: Continents['Other destinations']
      },
      {
        value: 225,
        label: 'Guernsey',
        continent: Continents['Other destinations']
      }
    ],
    destinationsIDsToRemove2024B: [
      {
        value: 311,
        label: 'Uzbekistan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 312,
        label: 'Kyrgyzstan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 313,
        label: 'Kazakhstan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 314,
        label: 'Tajikistan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 315,
        label: 'Turkmenistan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 317,
        label: 'Bahrain',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 318,
        label: 'Kuwait',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 274,
        label: 'Malaga',
        continent: Continents['Other destinations']
      },
      {
        value: 275,
        label: 'Costa del Sol',
        continent: Continents['Other destinations']
      },
      {
        value: 113,
        label: 'Fort Myers',
        continent: Continents['Other destinations']
      },
      {
        value: 300,
        label: 'Martinique (France)',
        continent: Continents['Other destinations']
      },
      {
        value: 301,
        label: 'Guadeloupe (France)',
        continent: Continents['Other destinations']
      }
    ],
    destinationsIDs2025B: [
      {
        label: 'St. Martin',
        continent: Continents.Africa,
        value: 289
      },
      {
        label: 'Taiwan',
        continent: Continents['Other destinations'],
        value: 290
      }
      //   {
      //     label: 'Benidorm',
      //     continent: Continents['Other destinations'],
      //     value: 291
      //   }
    ],
    destinationsIDs2025A: [
      {
        label: 'Malawi',
        continent: Continents.Africa,
        value: 288
      },
      {
        label: 'Cadiz',
        continent: Continents['Other destinations'],
        value: 286
      },
      {
        label: 'Granada',
        continent: Continents['Other destinations'],
        value: 287
      }
    ],
    destinationsIDs2024B: [
      {
        label: 'Suriname',
        continent: Continents.America,
        value: 324
      },
      {
        label: 'Los Cabos',
        continent: Continents['Other destinations'],
        value: 325
      },
      {
        label: 'Aspen',
        continent: Continents.America,
        value: 326
      },
      {
        label: 'Costa del Sol - Malaga',
        continent: Continents['Other destinations'],
        value: 375
      },
      {
        label: 'Lanzarote',
        continent: Continents['Other destinations'],
        value: 322
      },
      {
        label: 'Fuerteventura',
        continent: Continents['Other destinations'],
        value: 323
      }
    ],
    destinationsIDs2024A: [
      {
        value: 308,
        label: 'Arizona',
        continent: Continents['Other destinations']
      },
      {
        value: 305,
        label: 'Philladelphia',
        continent: Continents['Other destinations']
      },
      {
        value: 303,
        label: 'Louisiana',
        continent: Continents['Other destinations']
      },
      {
        value: 306,
        label: 'Nevada',
        continent: Continents['Other destinations']
      },
      {
        value: 304,
        label: 'New Orleans',
        continent: Continents['Other destinations']
      },
      {
        value: 307,
        label: 'Washington',
        continent: Continents['Other destinations']
      },
      {
        value: 319,
        label: 'Andalusia',
        continent: Continents['Other destinations']
      },
      {
        value: 311,
        label: 'Uzbekistan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 312,
        label: 'Kyrgyzstan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 313,
        label: 'Kazakhstan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 314,
        label: 'Tajikistan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 315,
        label: 'Turkmenistan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 316,
        label: 'United Arab Emirates',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 317,
        label: 'Bahrain',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 318,
        label: 'Kuwait',
        continent: Continents['Asia & Oceania']
      }
    ],
    destinationsIDs2023B: [
      {
        value: 300,
        label: 'Martinique (France)',
        continent: Continents['Other destinations']
      },
      {
        value: 301,
        label: 'Guadeloupe (France)',
        continent: Continents['Other destinations']
      },
      {
        value: 302,
        label: 'La Réunion (France)',
        continent: Continents['Other destinations']
      },
      {
        value: 310,
        label: 'New South Wales - AUS',
        continent: Continents['Other destinations']
      }
    ],
    destinationsIDs2023A: [],
    destinationsIDs2022B: [
      {
        value: 284,
        label: 'Pittsburgh',
        continent: Continents['Other destinations']
      },
      {
        value: 285,
        label: 'Greater Palm Spring',
        continent: Continents['Other destinations']
      },
      {
        value: 283,
        label: 'French Polynesia',
        continent: Continents['Other destinations']
      },
      {
        value: 213,
        label: 'Antigua and Barbuda',
        continent: Continents.America
      }
    ],
    destinationsIDs2022A: [
      {
        value: 282,
        label: 'Grenada',
        continent: Continents['Other destinations']
      },
      {
        value: 279,
        label: 'Bolivia',
        continent: Continents.America
      },
      {
        value: 271,
        label: 'California',
        continent: Continents['Other destinations']
      },
      {
        value: 273,
        label: 'Florida',
        continent: Continents['Other destinations']
      },
      {
        value: 274,
        label: 'Malaga',
        continent: Continents['Other destinations']
      },
      {
        value: 275,
        label: 'Costa del Sol',
        continent: Continents['Other destinations']
      },
      {
        value: 276,
        label: 'Gran Canaria',
        continent: Continents['Other destinations']
      },
      {
        value: 277,
        label: 'Madrid',
        continent: Continents['Other destinations']
      },
      {
        value: 278,
        label: 'Valencia',
        continent: Continents['Other destinations']
      },
      {
        value: 280,
        label: 'New Caledonia (France)',
        continent: Continents['Other destinations']
      },
      {
        value: 281,
        label: 'Trentino',
        continent: Continents['Other destinations']
      }
    ],
    destinationsIDs2021: [
      {
        value: 99 + destination_magicnumber_to_add,
        label: 'Germany',
        continent: Continents.Europe
      },
      {
        value: 106 + destination_magicnumber_to_add,
        label: 'Austria',
        continent: Continents.Europe
      },
      {
        value: 83 + destination_magicnumber_to_add,
        label: 'Switzerland',
        continent: Continents.Europe
      },
      {
        value: 56 + destination_magicnumber_to_add,
        label: 'Italy',
        continent: Continents.Europe
      },
      {
        value: 235,
        label: 'St Marino',
        continent: Continents.Europe
      },
      {
        value: 67 + destination_magicnumber_to_add,
        label: 'Malta',
        continent: Continents.Europe
      },
      {
        value: 236,
        label: 'Monaco',
        continent: Continents.Europe
      },
      {
        value: 45 + destination_magicnumber_to_add,
        label: 'France',
        continent: Continents.Europe
      },
      {
        value: 201,
        label: 'Andorra',
        continent: Continents.Europe
      },
      {
        value: 90 + destination_magicnumber_to_add,
        label: 'Spain',
        continent: Continents.Europe
      },
      {
        value: 78 + destination_magicnumber_to_add,
        label: 'Portugal',
        continent: Continents.Europe
      },
      {
        value: 119 + destination_magicnumber_to_add,
        label: 'Luxembourg',
        continent: Continents.Europe
      },
      {
        value: 28 + destination_magicnumber_to_add,
        label: 'Belgium',
        continent: Continents.Europe
      },
      {
        value: 50 + destination_magicnumber_to_add,
        label: 'Netherlands',
        continent: Continents.Europe
      },
      {
        value: 237,
        label: 'United Kingdom',
        continent: Continents.Europe
      },
      {
        value: 87 + destination_magicnumber_to_add,
        label: 'Scotland',
        continent: Continents.Europe
      },
      {
        value: 53 + destination_magicnumber_to_add,
        label: 'Ireland',
        continent: Continents.Europe
      },
      {
        value: 54 + destination_magicnumber_to_add,
        label: 'Iceland',
        continent: Continents.Europe
      },
      {
        value: 46 + destination_magicnumber_to_add,
        label: 'Faroe Islands',
        continent: Continents.Europe
      },
      {
        value: 20 + destination_magicnumber_to_add,
        label: 'Denmark',
        continent: Continents.Europe
      },
      {
        value: 22 + destination_magicnumber_to_add,
        label: 'Norway',
        continent: Continents.Europe
      },
      {
        value: 21 + destination_magicnumber_to_add,
        label: 'Sweden',
        continent: Continents.Europe
      },
      {
        value: 23 + destination_magicnumber_to_add,
        label: 'Finland',
        continent: Continents.Europe
      },
      {
        value: 112 + destination_magicnumber_to_add,
        label: 'Estonia',
        continent: Continents.Europe
      },
      {
        value: 117 + destination_magicnumber_to_add,
        label: 'Latvia',
        continent: Continents.Europe
      },
      {
        value: 118 + destination_magicnumber_to_add,
        label: 'Lithuania',
        continent: Continents.Europe
      },
      {
        value: 77 + destination_magicnumber_to_add,
        label: 'Poland',
        continent: Continents.Europe
      },
      {
        value: 238,
        label: 'Czech Republic',
        continent: Continents.Europe
      },
      {
        value: 88 + destination_magicnumber_to_add,
        label: 'Slovakia',
        continent: Continents.Europe
      },
      {
        value: 100 + destination_magicnumber_to_add,
        label: 'Hungary',
        continent: Continents.Europe
      },
      {
        value: 89 + destination_magicnumber_to_add,
        label: 'Slovenia',
        continent: Continents.Europe
      },
      {
        value: 239,
        label: 'Croatia',
        continent: Continents.Europe
      },
      {
        value: 240,
        label: 'Bosnia y Herzegovina',
        continent: Continents.Europe
      },
      {
        value: 84 + destination_magicnumber_to_add,
        label: 'Serbia',
        continent: Continents.Europe
      },
      {
        value: 203,
        label: 'Montenegro',
        continent: Continents.Europe
      },
      {
        value: 25 + destination_magicnumber_to_add,
        label: 'Albania',
        continent: Continents.Europe
      },
      {
        value: 241,
        label: 'Macedonia',
        continent: Continents.Europe
      },
      {
        value: 31 + destination_magicnumber_to_add,
        label: 'Bulgaria',
        continent: Continents.Europe
      },
      {
        value: 81 + destination_magicnumber_to_add,
        label: 'Romania',
        continent: Continents.Europe
      },
      {
        value: 48 + destination_magicnumber_to_add,
        label: 'Greece',
        continent: Continents.Europe
      },
      {
        value: 37 + destination_magicnumber_to_add,
        label: 'Cyprus',
        continent: Continents.Europe
      },
      {
        value: 98 + destination_magicnumber_to_add,
        label: 'Turkey',
        continent: Continents.Europe
      },
      {
        value: 202,
        label: 'Georgia',
        continent: Continents.Europe
      },
      {
        value: 242,
        label: 'Azerbaijan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 82 + destination_magicnumber_to_add,
        label: 'Russia',
        continent: Continents.Europe
      },
      {
        value: 32 + destination_magicnumber_to_add,
        label: 'Canada',
        continent: Continents.America
      },
      {
        value: 243,
        label: 'United States of America',
        continent: Continents.America
      },
      {
        value: 70 + destination_magicnumber_to_add,
        label: 'Mexico',
        continent: Continents.America
      },
      {
        value: 108 + destination_magicnumber_to_add,
        label: 'Bahamas',
        continent: Continents.America
      },
      {
        value: 36 + destination_magicnumber_to_add,
        label: 'Cuba',
        continent: Continents.America
      },
      {
        value: 114 + destination_magicnumber_to_add,
        label: 'Jamaica',
        continent: Continents.America
      },
      {
        value: 244,
        label: 'The Dominican Republic',
        continent: Continents.America
      },
      {
        value: 217,
        label: 'St Lucia',
        continent: Continents.America
      },
      {
        value: 109 + destination_magicnumber_to_add,
        label: 'Barbados',
        continent: Continents.America
      },
      {
        value: 245,
        label: 'Guatemala',
        continent: Continents.America
      },
      {
        value: 246,
        label: 'Honduras',
        continent: Continents.America
      },
      {
        value: 35 + destination_magicnumber_to_add,
        label: 'Costa Rica',
        continent: Continents.America
      },
      {
        value: 75 + destination_magicnumber_to_add,
        label: 'Panama',
        continent: Continents.America
      },
      {
        value: 107 + destination_magicnumber_to_add,
        label: 'Aruba',
        continent: Continents.America
      },
      {
        value: 34 + destination_magicnumber_to_add,
        label: 'Colombia',
        continent: Continents.America
      },
      {
        value: 41 + destination_magicnumber_to_add,
        label: 'Ecuador',
        continent: Continents.America
      },
      {
        value: 76 + destination_magicnumber_to_add,
        label: 'Peru',
        continent: Continents.America
      },
      {
        value: 247,
        label: 'Brasil',
        continent: Continents.America
      },
      {
        value: 33 + destination_magicnumber_to_add,
        label: 'Chile',
        continent: Continents.America
      },
      {
        value: 248,
        label: 'Paraguay',
        continent: Continents.America
      },
      {
        value: 26 + destination_magicnumber_to_add,
        label: 'Argentina',
        continent: Continents.America
      },
      {
        value: 249,
        label: 'Uruguay',
        continent: Continents.America
      },
      {
        value: 68 + destination_magicnumber_to_add,
        label: 'Morocco',
        continent: Continents.Africa
      },
      {
        value: 97 + destination_magicnumber_to_add,
        label: 'Tunisia',
        continent: Continents.Africa
      },
      {
        value: 42 + destination_magicnumber_to_add,
        label: 'Egypt',
        continent: Continents['Middle East']
      },
      {
        value: 59 + destination_magicnumber_to_add,
        label: 'Cape Verde',
        continent: Continents.Africa
      },
      {
        value: 250,
        label: 'Senegal',
        continent: Continents.Africa
      },
      {
        value: 47 + destination_magicnumber_to_add,
        label: 'Gambia',
        continent: Continents.Africa
      },
      {
        value: 60 + destination_magicnumber_to_add,
        label: 'Kenya',
        continent: Continents.Africa
      },
      {
        value: 122 + destination_magicnumber_to_add,
        label: 'Rwanda',
        continent: Continents.Africa
      },
      {
        value: 251,
        label: 'Tanzania',
        continent: Continents.Africa
      },
      {
        value: 252,
        label: 'Zambia',
        continent: Continents.Africa
      },
      {
        value: 85 + destination_magicnumber_to_add,
        label: 'Seychelles',
        continent: Continents.Africa
      },
      {
        value: 63 + destination_magicnumber_to_add,
        label: 'Madagascar',
        continent: Continents.Africa
      },
      {
        value: 69 + destination_magicnumber_to_add,
        label: 'Mauritius',
        continent: Continents.Africa
      },
      {
        value: 253,
        label: 'Botswana',
        continent: Continents.Africa
      },
      {
        value: 121 + destination_magicnumber_to_add,
        label: 'Namibia',
        continent: Continents.Africa
      },
      {
        value: 92 + destination_magicnumber_to_add,
        label: 'South Africa',
        continent: Continents.Africa
      },
      {
        value: 55 + destination_magicnumber_to_add,
        label: 'Israel',
        continent: Continents['Middle East']
      },
      {
        value: 58 + destination_magicnumber_to_add,
        label: 'Jordan',
        continent: Continents['Middle East']
      },
      {
        value: 212,
        label: 'Saudi Arabia',
        continent: Continents['Middle East']
      },
      {
        value: 73 + destination_magicnumber_to_add,
        label: 'Oman',
        continent: Continents['Middle East']
      },
      {
        value: 80 + destination_magicnumber_to_add,
        label: 'Qatar',
        continent: Continents['Middle East']
      },
      {
        value: 24 + destination_magicnumber_to_add,
        label: 'Abu Dhabi',
        continent: Continents['Middle East']
      },
      {
        value: 40 + destination_magicnumber_to_add,
        label: 'Dubai',
        continent: Continents['Middle East']
      },
      {
        value: 51 + destination_magicnumber_to_add,
        label: 'India',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 91 + destination_magicnumber_to_add,
        label: 'Sri Lanka',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 254,
        label: 'Maldives',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 71 + destination_magicnumber_to_add,
        label: 'Nepal',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 61 + destination_magicnumber_to_add,
        label: 'China',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 255,
        label: 'Myanmar (Burma)',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 115 + destination_magicnumber_to_add,
        label: 'Laos',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 95 + destination_magicnumber_to_add,
        label: 'Thailand',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 103 + destination_magicnumber_to_add,
        label: 'Vietnam',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 206,
        label: 'Cambodia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 65 + destination_magicnumber_to_add,
        label: 'Malaysia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 86 + destination_magicnumber_to_add,
        label: 'Singapore',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 52 + destination_magicnumber_to_add,
        label: 'Indonesia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 256,
        label: 'Philippines',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 57 + destination_magicnumber_to_add,
        label: 'Japan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 93 + destination_magicnumber_to_add,
        label: 'South Korea',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 43 + destination_magicnumber_to_add,
        label: 'Fiji',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 27 + destination_magicnumber_to_add,
        label: 'Australia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 72 + destination_magicnumber_to_add,
        label: 'New Zealand',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 49 + destination_magicnumber_to_add,
        label: 'Greenland',
        continent: Continents.Europe
      },
      {
        value: 259,
        label: 'Guyana French',
        continent: Continents.America
      },
      {
        value: 260,
        label: 'Guyana',
        continent: Continents['Other destinations']
      },
      {
        value: 207,
        label: 'Hong Kong',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 222,
        label: 'Canary Islands',
        continent: Continents['Other destinations']
      },
      {
        value: 257,
        label: 'Balearic Islands',
        continent: Continents['Other destinations']
      },
      {
        value: 258,
        label: 'Ras al Khaimah',
        continent: Continents['Middle East']
      },
      {
        value: 261,
        label: 'New York',
        continent: Continents['Other destinations']
      },
      {
        value: 262,
        label: 'Miami',
        continent: Continents['Other destinations']
      },
      {
        value: 263,
        label: 'Quebec',
        continent: Continents['Other destinations']
      },
      {
        value: 264,
        label: 'Madeira',
        continent: Continents['Other destinations']
      },
      {
        value: 266,
        label: 'Barcelona',
        continent: Continents['Other destinations']
      },
      {
        value: 113 + destination_magicnumber_to_add,
        label: 'Fort Myers',
        continent: Continents['Other destinations']
      },
      {
        value: 124 + destination_magicnumber_to_add,
        label: 'Tenerife',
        continent: Continents['Other destinations']
      },
      {
        value: 120 + destination_magicnumber_to_add,
        label: 'Macao',
        continent: Continents['Other destinations']
      },
      {
        value: 265,
        label: 'Catalonia',
        continent: Continents['Other destinations']
      },
      {
        value: 268,
        label: 'Costa Brava',
        continent: Continents['Other destinations']
      },
      {
        value: 267,
        label: 'Girona',
        continent: Continents['Other destinations']
      },
      {
        value: 269,
        label: 'Tarragona',
        continent: Continents['Other destinations']
      },
      {
        value: 125 + destination_magicnumber_to_add,
        label: 'Trinidad & Tobago',
        continent: Continents.America
      },
      {
        value: 270,
        label: 'Curacao',
        continent: Continents.America
      },
      {
        value: 226,
        label: 'Jersey',
        continent: Continents['Other destinations']
      },
      {
        value: 225,
        label: 'Guernsey',
        continent: Continents['Other destinations']
      }
    ],
    destinationsIDs2019: [
      {
        value: 99 + destination_magicnumber_to_add_for_2019,
        label: 'Germany',
        continent: Continents.Europe
      },
      {
        value: 106 + destination_magicnumber_to_add_for_2019,
        label: 'Austria',
        continent: Continents.Europe
      },
      {
        value: 83 + destination_magicnumber_to_add_for_2019,
        label: 'Switzerland',
        continent: Continents.Europe
      },
      {
        value: 56 + destination_magicnumber_to_add_for_2019,
        label: 'Italy',
        continent: Continents.Europe
      },
      {
        value: 235,
        label: 'St Marino',
        continent: Continents.Europe
      },
      {
        value: 67 + destination_magicnumber_to_add_for_2019,
        label: 'Malta',
        continent: Continents.Europe
      },
      {
        value: 236,
        label: 'Monaco',
        continent: Continents.Europe
      },
      {
        value: 45 + destination_magicnumber_to_add_for_2019,
        label: 'France',
        continent: Continents.Europe
      },
      {
        value: 201,
        label: 'Andorra',
        continent: Continents.Europe
      },
      {
        value: 90 + destination_magicnumber_to_add_for_2019,
        label: 'Spain',
        continent: Continents.Europe
      },
      {
        value: 78 + destination_magicnumber_to_add_for_2019,
        label: 'Portugal',
        continent: Continents.Europe
      },
      {
        value: 119 + destination_magicnumber_to_add_for_2019,
        label: 'Luxembourg',
        continent: Continents.Europe
      },
      {
        value: 28 + destination_magicnumber_to_add_for_2019,
        label: 'Belgium',
        continent: Continents.Europe
      },
      {
        value: 50 + destination_magicnumber_to_add_for_2019,
        label: 'Netherlands',
        continent: Continents.Europe
      },
      {
        value: 237,
        label: 'United Kingdom',
        continent: Continents.Europe
      },
      {
        value: 87 + destination_magicnumber_to_add_for_2019,
        label: 'Scotland',
        continent: Continents.Europe
      },
      {
        value: 53 + destination_magicnumber_to_add_for_2019,
        label: 'Ireland',
        continent: Continents.Europe
      },
      {
        value: 54 + destination_magicnumber_to_add_for_2019,
        label: 'Iceland',
        continent: Continents.Europe
      },
      {
        value: 46 + destination_magicnumber_to_add_for_2019,
        label: 'Faroe Islands',
        continent: Continents.Europe
      },
      {
        value: 20 + destination_magicnumber_to_add_for_2019,
        label: 'Denmark',
        continent: Continents.Europe
      },
      {
        value: 22 + destination_magicnumber_to_add_for_2019,
        label: 'Norway',
        continent: Continents.Europe
      },
      {
        value: 21 + destination_magicnumber_to_add_for_2019,
        label: 'Sweden',
        continent: Continents.Europe
      },
      {
        value: 23 + destination_magicnumber_to_add_for_2019,
        label: 'Finland',
        continent: Continents.Europe
      },
      {
        value: 112 + destination_magicnumber_to_add_for_2019,
        label: 'Estonia',
        continent: Continents.Europe
      },
      {
        value: 117 + destination_magicnumber_to_add_for_2019,
        label: 'Latvia',
        continent: Continents.Europe
      },
      {
        value: 118 + destination_magicnumber_to_add_for_2019,
        label: 'Lithuania',
        continent: Continents.Europe
      },
      {
        value: 77 + destination_magicnumber_to_add_for_2019,
        label: 'Poland',
        continent: Continents.Europe
      },
      {
        value: 238,
        label: 'Czech Republic',
        continent: Continents.Europe
      },
      {
        value: 88 + destination_magicnumber_to_add_for_2019,
        label: 'Slovakia',
        continent: Continents.Europe
      },
      {
        value: 100 + destination_magicnumber_to_add_for_2019,
        label: 'Hungary',
        continent: Continents.Europe
      },
      {
        value: 89 + destination_magicnumber_to_add_for_2019,
        label: 'Slovenia',
        continent: Continents.Europe
      },
      {
        value: 239,
        label: 'Croatia',
        continent: Continents.Europe
      },
      {
        value: 240,
        label: 'Bosnia y Herzegovina',
        continent: Continents.Europe
      },
      {
        value: 84 + destination_magicnumber_to_add_for_2019,
        label: 'Serbia',
        continent: Continents.Europe
      },
      {
        value: 203,
        label: 'Montenegro',
        continent: Continents.Europe
      },
      {
        value: 25 + destination_magicnumber_to_add_for_2019,
        label: 'Albania',
        continent: Continents.Europe
      },
      {
        value: 241,
        label: 'Macedonia',
        continent: Continents.Europe
      },
      {
        value: 31 + destination_magicnumber_to_add_for_2019,
        label: 'Bulgaria',
        continent: Continents.Europe
      },
      {
        value: 81 + destination_magicnumber_to_add_for_2019,
        label: 'Romania',
        continent: Continents.Europe
      },
      {
        value: 48 + destination_magicnumber_to_add_for_2019,
        label: 'Greece',
        continent: Continents.Europe
      },
      {
        value: 37 + destination_magicnumber_to_add_for_2019,
        label: 'Cyprus',
        continent: Continents.Europe
      },
      {
        value: 98 + destination_magicnumber_to_add_for_2019,
        label: 'Turkey',
        continent: Continents.Europe
      },
      {
        value: 202,
        label: 'Georgia',
        continent: Continents.Europe
      },
      {
        value: 242,
        label: 'Azerbaijan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 82 + destination_magicnumber_to_add_for_2019,
        label: 'Russia',
        continent: Continents.Europe
      },
      {
        value: 32 + destination_magicnumber_to_add_for_2019,
        label: 'Canada',
        continent: Continents.America
      },
      {
        value: 243,
        label: 'United States of America',
        continent: Continents.America
      },
      {
        value: 70 + destination_magicnumber_to_add_for_2019,
        label: 'Mexico',
        continent: Continents.America
      },
      {
        value: 108 + destination_magicnumber_to_add_for_2019,
        label: 'Bahamas',
        continent: Continents.America
      },
      {
        value: 36 + destination_magicnumber_to_add_for_2019,
        label: 'Cuba',
        continent: Continents.America
      },
      {
        value: 114 + destination_magicnumber_to_add_for_2019,
        label: 'Jamaica',
        continent: Continents.America
      },
      {
        value: 244,
        label: 'The Dominican Republic',
        continent: Continents.America
      },
      {
        value: 217,
        label: 'St Lucia',
        continent: Continents.America
      },
      {
        value: 109 + destination_magicnumber_to_add_for_2019,
        label: 'Barbados',
        continent: Continents.America
      },
      {
        value: 245,
        label: 'Guatemala',
        continent: Continents.America
      },
      {
        value: 246,
        label: 'Honduras',
        continent: Continents.America
      },
      {
        value: 35 + destination_magicnumber_to_add_for_2019,
        label: 'Costa Rica',
        continent: Continents.America
      },
      {
        value: 75 + destination_magicnumber_to_add_for_2019,
        label: 'Panama',
        continent: Continents.America
      },
      {
        value: 107 + destination_magicnumber_to_add_for_2019,
        label: 'Aruba',
        continent: Continents.America
      },
      {
        value: 34 + destination_magicnumber_to_add_for_2019,
        label: 'Colombia',
        continent: Continents.America
      },
      {
        value: 41 + destination_magicnumber_to_add_for_2019,
        label: 'Ecuador',
        continent: Continents.America
      },
      {
        value: 76 + destination_magicnumber_to_add_for_2019,
        label: 'Peru',
        continent: Continents.America
      },
      {
        value: 247,
        label: 'Brasil',
        continent: Continents.America
      },
      {
        value: 33 + destination_magicnumber_to_add_for_2019,
        label: 'Chile',
        continent: Continents.America
      },
      {
        value: 248,
        label: 'Paraguay',
        continent: Continents.America
      },
      {
        value: 26 + destination_magicnumber_to_add_for_2019,
        label: 'Argentina',
        continent: Continents.America
      },
      {
        value: 249,
        label: 'Uruguay',
        continent: Continents.America
      },
      {
        value: 68 + destination_magicnumber_to_add_for_2019,
        label: 'Morocco',
        continent: Continents.Africa
      },
      {
        value: 97 + destination_magicnumber_to_add_for_2019,
        label: 'Tunisia',
        continent: Continents.Africa
      },
      {
        value: 42 + destination_magicnumber_to_add_for_2019,
        label: 'Egypt',
        continent: Continents['Middle East']
      },
      {
        value: 59 + destination_magicnumber_to_add_for_2019,
        label: 'Cape Verde',
        continent: Continents.Africa
      },
      {
        value: 250,
        label: 'Senegal',
        continent: Continents.Africa
      },
      {
        value: 47 + destination_magicnumber_to_add_for_2019,
        label: 'Gambia',
        continent: Continents.Africa
      },
      {
        value: 60 + destination_magicnumber_to_add_for_2019,
        label: 'Kenya',
        continent: Continents.Africa
      },
      {
        value: 122 + destination_magicnumber_to_add_for_2019,
        label: 'Rwanda',
        continent: Continents.Africa
      },
      {
        value: 251,
        label: 'Tanzania',
        continent: Continents.Africa
      },
      {
        value: 252,
        label: 'Zambia',
        continent: Continents.Africa
      },
      {
        value: 85 + destination_magicnumber_to_add_for_2019,
        label: 'Seychelles',
        continent: Continents.Africa
      },
      {
        value: 63 + destination_magicnumber_to_add_for_2019,
        label: 'Madagascar',
        continent: Continents.Africa
      },
      {
        value: 69 + destination_magicnumber_to_add_for_2019,
        label: 'Mauritius',
        continent: Continents.Africa
      },
      {
        value: 253,
        label: 'Botswana',
        continent: Continents.Africa
      },
      {
        value: 121 + destination_magicnumber_to_add_for_2019,
        label: 'Namibia',
        continent: Continents.Africa
      },
      {
        value: 92 + destination_magicnumber_to_add_for_2019,
        label: 'South Africa',
        continent: Continents.Africa
      },
      {
        value: 55 + destination_magicnumber_to_add_for_2019,
        label: 'Israel',
        continent: Continents['Middle East']
      },
      {
        value: 58 + destination_magicnumber_to_add_for_2019,
        label: 'Jordan',
        continent: Continents['Middle East']
      },
      {
        value: 212,
        label: 'Saudi Arabia',
        continent: Continents['Middle East']
      },
      {
        value: 73 + destination_magicnumber_to_add_for_2019,
        label: 'Oman',
        continent: Continents['Middle East']
      },
      {
        value: 80 + destination_magicnumber_to_add_for_2019,
        label: 'Qatar',
        continent: Continents['Middle East']
      },
      {
        value: 24 + destination_magicnumber_to_add_for_2019,
        label: 'Abu Dhabi',
        continent: Continents['Middle East']
      },
      {
        value: 40 + destination_magicnumber_to_add_for_2019,
        label: 'Dubai',
        continent: Continents['Middle East']
      },
      {
        value: 51 + destination_magicnumber_to_add_for_2019,
        label: 'India',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 91 + destination_magicnumber_to_add_for_2019,
        label: 'Sri Lanka',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 254,
        label: 'Maldives',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 71 + destination_magicnumber_to_add_for_2019,
        label: 'Nepal',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 61 + destination_magicnumber_to_add_for_2019,
        label: 'China',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 255,
        label: 'Myanmar (Burma)',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 115 + destination_magicnumber_to_add_for_2019,
        label: 'Laos',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 95 + destination_magicnumber_to_add_for_2019,
        label: 'Thailand',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 103 + destination_magicnumber_to_add_for_2019,
        label: 'Vietnam',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 206,
        label: 'Cambodia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 65 + destination_magicnumber_to_add_for_2019,
        label: 'Malaysia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 86 + destination_magicnumber_to_add_for_2019,
        label: 'Singapore',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 52 + destination_magicnumber_to_add_for_2019,
        label: 'Indonesia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 256,
        label: 'Philippines',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 57 + destination_magicnumber_to_add_for_2019,
        label: 'Japan',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 93 + destination_magicnumber_to_add_for_2019,
        label: 'South Korea',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 43 + destination_magicnumber_to_add_for_2019,
        label: 'Fiji',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 27 + destination_magicnumber_to_add_for_2019,
        label: 'Australia',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 72 + destination_magicnumber_to_add_for_2019,
        label: 'New Zealand',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 49 + destination_magicnumber_to_add_for_2019,
        label: 'Greenland',
        continent: Continents.Europe
      },
      {
        value: 259,
        label: 'Guyana French',
        continent: Continents.America
      },
      {
        value: 260,
        label: 'Guyana',
        continent: Continents['Other destinations']
      },
      {
        value: 207,
        label: 'Hong Kong',
        continent: Continents['Asia & Oceania']
      },
      {
        value: 222,
        label: 'Canary Islands',
        continent: Continents['Other destinations']
      },
      {
        value: 257,
        label: 'Balearic Islands',
        continent: Continents['Other destinations']
      },
      {
        value: 258,
        label: 'Ras al Khaimah',
        continent: Continents['Middle East']
      },
      {
        value: 261,
        label: 'New York',
        continent: Continents['Other destinations']
      },
      {
        value: 262,
        label: 'Miami',
        continent: Continents['Other destinations']
      },
      {
        value: 263,
        label: 'Quebec',
        continent: Continents['Other destinations']
      },
      {
        value: 264,
        label: 'Madeira',
        continent: Continents['Other destinations']
      },
      {
        value: 266,
        label: 'Barcelona',
        continent: Continents['Other destinations']
      },
      {
        value: 113 + destination_magicnumber_to_add_for_2019,
        label: 'Fort Myers',
        continent: Continents['Other destinations']
      },
      {
        value: 124 + destination_magicnumber_to_add_for_2019,
        label: 'Tenerife',
        continent: Continents['Other destinations']
      },
      {
        value: 120 + destination_magicnumber_to_add_for_2019,
        label: 'Macao',
        continent: Continents['Other destinations']
      },
      {
        value: 265,
        label: 'Catalonia',
        continent: Continents['Other destinations']
      },
      {
        value: 268,
        label: 'Costa Brava',
        continent: Continents['Other destinations']
      },
      {
        value: 267,
        label: 'Girona',
        continent: Continents['Other destinations']
      },
      {
        value: 269,
        label: 'Tarragona',
        continent: Continents['Other destinations']
      },
      {
        value: 125 + destination_magicnumber_to_add_for_2019,
        label: 'Trinidad & Tobago',
        continent: Continents.America
      },
      {
        value: 270,
        label: 'Curacao',
        continent: Continents.America
      },
      {
        value: 226,
        label: 'Jersey',
        continent: Continents['Other destinations']
      },
      {
        value: 225,
        label: 'Guernsey',
        continent: Continents['Other destinations']
      }
    ]
  };
}
